import { collection, addDoc, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import { createPrintHistoryModel, PRINT_TYPES, TEMPLATE_TYPES } from '../data/printHistoryModel';

/**
 * บันทึก Print History
 * สำหรับ Premium และ Enterprise packages เท่านั้น
 */
export const savePrintHistory = async (data) => {
  try {
    const printHistory = createPrintHistoryModel(data);
    const docRef = await addDoc(collection(db, 'printHistory'), printHistory);
    return {
      success: true,
      id: docRef.id
    };
  } catch (error) {
    console.error('Error saving print history:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * ดึง Print History ของร้าน
 */
export const getPrintHistoryByStore = async (storeId, limitCount = 50) => {
  try {
    const q = query(
      collection(db, 'printHistory'),
      where('storeId', '==', storeId),
      orderBy('printedAt', 'desc'),
      limit(limitCount)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error fetching print history:', error);
    return [];
  }
};

/**
 * ดึง Print History ของออเดอร์
 */
export const getPrintHistoryByOrder = async (orderId) => {
  try {
    const q = query(
      collection(db, 'printHistory'),
      where('orderId', '==', orderId),
      orderBy('printedAt', 'desc')
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error fetching print history by order:', error);
    return [];
  }
};

export { PRINT_TYPES, TEMPLATE_TYPES };









